import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5990afa5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "list-comment border-bottom mb-4 pb-2"
}
const _hoisted_2 = ["data-bs-target"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "d-flex justify-content-between" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "fs-7 fw-bold cursor-pointer"
}
const _hoisted_8 = {
  key: 1,
  class: "fs-7 fw-bold cursor-pointer"
}
const _hoisted_9 = {
  key: 1,
  class: "fs-7 fw-bold"
}
const _hoisted_10 = {
  key: 0,
  class: "fs-7 fw-bold cursor-pointer"
}
const _hoisted_11 = {
  key: 1,
  class: "fs-7 fw-bold cursor-pointer"
}
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = {
  key: 0,
  class: "fas fa-eye-slash cursor-pointer me-2"
}
const _hoisted_14 = { class: "submenu" }
const _hoisted_15 = { class: "d-block mb-2 fs-8" }
const _hoisted_16 = ["id"]
const _hoisted_17 = { class: "d-flex justify-content-between" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "fs-7 fw-bold cursor-pointer"
}
const _hoisted_20 = {
  key: 1,
  class: "fs-7 fw-bold cursor-pointer"
}
const _hoisted_21 = {
  key: 1,
  class: "fs-7 fw-bold"
}
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = {
  key: 0,
  class: "fas fa-eye-slash cursor-pointer me-2"
}
const _hoisted_24 = { class: "submenu" }
const _hoisted_25 = { class: "d-block mb-2 fs-8" }

import Avatar from '@/components/avatar/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { UserType } from '@/store/modules/post'
import { computed, PropType, ref, ComputedRef } from 'vue-demi'
import Submenu from '@/components/submenu/subMenuAdmin.vue'
import { translate } from '@/languages/i18n'
import { useStore } from 'vuex'
import { ACCOUNT_STORE, USER_POST_STORE } from '@/store/constants'
import { SetCurrentComment } from '@/store/modules/user-post/user-post.mutations'
import TargetTag from '@/components/target-tag/index.vue'
import { ReplayName, numberWithCommas } from '@/constants/common'
import { useRoute } from 'vue-router'
import dayjs from 'dayjs'
import { Modal, Collapse } from 'bootstrap'
import PortfolioAlumni from '@/views/community-admin/user-management/alumni-user/detail/components/PortfolioAlumni.vue'
import PortfolioUser from '@/views/community-admin/user-management/employee-user/detail/components/PortfolioUser.vue'
import { watch, nextTick, onMounted } from 'vue'
export type CommentType = {
  id: string
  post_id: string
  comment: string
  created_at: string
  display_name: string
  image_url: string
  user_type: UserType
}


export default /*#__PURE__*/_defineComponent({
  props: {
  comments: {
    type: Array as PropType<Array<CommentType>>,
    default: () => [],
  },
  postId: {
    type: Number,
  },
  comment_count: {
    type: Number,
  },
  mention_users: {
    type: Object,
  },
  id_comment: {
    type: String,
    default: null,
  },
},
  emits: ['setCommentData', 'showDeleteCommentModal', 'showUpdateCommentErrorModal', 'showUpdateStatusCommentModal'],
  setup(__props, { emit }) {

const props = __props


const route = useRoute()
const store = useStore()
const modal = ref()
const showAllComments = computed<ComputedRef<boolean>>(() => store.getters[USER_POST_STORE.GETTERS.SHOW_ALL_COMMENTS])
const showModal = computed(() => store.getters[ACCOUNT_STORE.GETTERS.PROFILE_DETAIL]?.showModal)

const published = ref<boolean>(false)



const setCommentData = (post_id, id, published) => {
  emit('setCommentData', post_id, id, published)
}

const showDeleteCommentModal = () => {
  emit('showDeleteCommentModal')
}

const showUpdateCommentErrorModal = () => {
  emit('showUpdateCommentErrorModal')
}

const showUpdateStatusCommentModal = () => {
  emit('showUpdateStatusCommentModal')
}

const menu = computed(() => {
  if (published.value) {
    return [
      { icon: '<i class="fas fa-eye-slash" />', title: translate('privateComment'), action: 'update' },
      { icon: '<i class="far fa-trash-alt" />', title: translate('deleteComment'), action: 'delete' },
    ]
  } else {
    return [
      { icon: `<img src="${require('@/assets/images/eye.svg')}" width="19" height="19" />`, title: translate('publicAdmin'), action: 'update' },
      { icon: '<i class="far fa-trash-alt" />', title: translate('deleteComment'), action: 'delete' },
    ]
  }
})

const setCurrentComment = (id: string, publish: boolean): void => {
  const payload: SetCurrentComment = {
    post_id: props.postId,
    comment_id: id,
  }
  published.value = publish
  store.dispatch(USER_POST_STORE.ACTIONS.SET_CURRENT_COMMENT, payload)
}

const handleShowUser = async (id, userID, userType, is_deleted_in_30_days) => {
  if (userType === 'community_admin' || is_deleted_in_30_days === 2) {
    return
  }
  modal.value = new Modal(document.getElementById(userType === 'alumni' ? 'editProfileModal' : 'profileUserModal'))

  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_PROFILE_DETAIL, { id, userID, userType, isAdmin: true })
  if (showModal.value) {
    await modal.value?.show()
  }
}
const ShowAll = () => {
  store.dispatch(USER_POST_STORE.ACTIONS.SET_SHOW_ALL_COMMENTS, !showAllComments.value)
}

const getComments = async () => {
  const payload = {
    community_id: route?.params?.id,
    params: {
      post_id: props?.postId,
      create_by_admin: true,
    },
  }
  //2022/11/28 PhuongTT Fix for UAT#5451 (Ph2-R20221222)
  await store.dispatch(USER_POST_STORE.ACTIONS.SET_LIST_COMMENT_USER_POST, payload)
}

onMounted(() => {
  const modalElement = document.getElementById('modalPost')
  if (modalElement) {
    modalElement.addEventListener('shown.bs.modal', () => {
      nextTick(() => {
        if (route.query?.target_content_id) {
          const isCommentIdLast = props.comments.slice(-1)[0]?.id == props.id_comment
          const collapseElement = document.getElementById(`flush-collapse${props.postId}`)
          if (isCommentIdLast) {
            scrollToComment()
          } else if (collapseElement) {
            store.dispatch(USER_POST_STORE.ACTIONS.SET_SHOW_ALL_COMMENTS, true)
            const bsCollapse = new Collapse(collapseElement, { toggle: false })
            bsCollapse.show()
          }
        }
      })
    })
  }
})

const scrollToComment = () => {
  const interval = setInterval(() => {
    const element = document.getElementById(props.id_comment) as HTMLElement | null
    if (element && !stopScroll.value) {
      clearInterval(interval)
      stopScroll.value = true
      const modalPost = document.getElementById('modalPost')
      const elementPosition = element.getBoundingClientRect().top - 20
      modalPost?.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      })
      stopScroll.value = false
    }
  }, 100)
  setTimeout(() => {
    clearInterval(interval)
  }, 5000)
}

const stopScroll = ref(false)
watch(
  () => showAllComments.value,
  async () => {
    if (showAllComments.value) {
      await getComments()
      if (props.id_comment && !stopScroll.value) {
        setTimeout(() => {
          scrollToComment()
        }, 300)
      }
    } else {
      stopScroll.value = false
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.comment_count > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (__props.comment_count > 1)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: "text-decoration-underline fs-75 cursor-pointer mb-4",
                "data-bs-toggle": "collapse",
                "data-bs-target": `#flush-collapse${__props.postId}`,
                "aria-expanded": "false",
                "aria-controls": "flush-collapseOne",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (ShowAll()))
              }, [
                _createTextVNode("他" + _toDisplayString(_unref(numberWithCommas)(__props.comment_count - 1)) + "件のコメントを見る ", 1),
                _createElementVNode("i", {
                  class: _normalizeClass(["fas fa-caret-down", [_unref(showAllComments) ? 'rotate' : '']])
                }, null, 2)
              ], 8, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            id: `flush-collapse${__props.postId}`,
            class: _normalizeClass(['accordion-collapse collapse', { show: _unref(showAllComments) }]),
            "aria-labelledby": "flush-headingOne",
            "data-bs-parent": "#accordionFlushExample"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.comments.slice(0, -1), (comment) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "user mb-3 d-flex",
                key: comment.id,
                id: comment.id
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(!comment?.published ? 'opacity-30' : '')
                }, [
                  _createVNode(Avatar, {
                    is_deleted_in_30_days: comment.is_deleted_in_30_days,
                    user_image_url: comment?.image_url,
                    size: 'small',
                    userType: comment.user_type
                  }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["w-100", { 'message-highlight': comment.id === __props.id_comment }])
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["d-flex", !comment?.published ? 'opacity-30' : ''])
                    }, [
                      _createVNode(UserAliasIcon, {
                        userType: comment.user_type,
                        class: "mb-2 fw-bold"
                      }, null, 8, ["userType"]),
                      (comment.is_deleted_in_30_days !== 2)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: () => handleShowUser(_unref(route).params.id, comment?.management_no, comment?.user_type)
                          }, [
                            (comment?.user_type !== 'community_admin')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(comment?.management_no + ' ' + _unref(ReplayName)(comment?.is_deleted_in_30_days, comment?.available, comment?.family_name, comment?.given_name, comment?.user_type)) + " " + _toDisplayString(comment?.user_type == 'alumni' && [0, 1].includes(comment?.is_deleted_in_30_days) ? `（ ${comment?.display_name} ）` : ''), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(comment?.management_no + ' ' + comment?.display_name), 1))
                          ], 8, _hoisted_6))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                            (comment?.user_type !== 'community_admin')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(comment?.management_no + ' ' + _unref(ReplayName)(comment?.is_deleted_in_30_days, comment?.available, comment?.family_name, comment?.given_name, comment?.user_type)) + " " + _toDisplayString(comment?.user_type == 'alumni' && [0, 1].includes(comment?.is_deleted_in_30_days) ? `（ ${comment?.display_name} ）` : ''), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(comment?.management_no + ' ' + comment?.display_name), 1))
                          ]))
                    ], 2),
                    _createElementVNode("div", _hoisted_12, [
                      (!comment?.published)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(Submenu, {
                          revert: !_ctx.checkChatBelongLoggedInUser,
                          menu: _unref(menu),
                          onShowDeleteCommentModal: showDeleteCommentModal,
                          onShowUpdateCommentErrorModal: showUpdateCommentErrorModal,
                          onShowUpdateStatusCommentModal: showUpdateStatusCommentModal,
                          onClick: 
                    () => {
                      setCurrentComment(comment.id, comment.published)
                      setCommentData(comment.post_id, comment.id, comment.published)
                    }
                  ,
                          published: comment?.published
                        }, null, 8, ["revert", "menu", "onClick", "published"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(!comment?.published ? 'opacity-30' : '')
                  }, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(dayjs)(comment?.created_at).format('YYYY/MM/DD HH:mm')), 1),
                    _createVNode(TargetTag, {
                      data: comment?.comment,
                      class: _normalizeClass('mb-0 fs-7 text-break break-spaces'),
                      users: __props.mention_users
                    }, null, 8, ["data", "users"])
                  ], 2)
                ], 2)
              ], 8, _hoisted_4))
            }), 128))
          ], 10, _hoisted_3),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.comments.slice(-1), (comment) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "user mb-3 d-flex",
              key: comment.id,
              id: comment.id
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(!comment?.published ? 'opacity-30' : '')
              }, [
                _createVNode(Avatar, {
                  is_deleted_in_30_days: comment.is_deleted_in_30_days,
                  user_image_url: comment?.image_url,
                  size: 'small',
                  userType: comment.user_type
                }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["w-100", { 'message-highlight': comment.id === __props.id_comment }])
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["d-flex", !comment?.published ? 'opacity-30' : ''])
                  }, [
                    _createVNode(UserAliasIcon, {
                      userType: comment.user_type,
                      class: "mb-2 fw-bold"
                    }, null, 8, ["userType"]),
                    (comment.is_deleted_in_30_days !== 2)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: () => handleShowUser(_unref(route).params.id, comment?.management_no, comment?.user_type)
                        }, [
                          (comment?.user_type !== 'community_admin')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(comment?.management_no + ' ' + _unref(ReplayName)(comment?.is_deleted_in_30_days, comment?.available, comment?.family_name, comment?.given_name, comment?.user_type)) + " " + _toDisplayString(comment?.user_type == 'alumni' && [0, 1].includes(comment?.is_deleted_in_30_days) ? `（ ${comment?.display_name} ）` : ''), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(comment?.management_no + ' ' + comment?.display_name), 1))
                        ], 8, _hoisted_18))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(comment?.management_no + ' ' + _unref(ReplayName)(comment?.is_deleted_in_30_days, comment?.available, comment?.family_name, comment?.given_name, comment?.user_type)) + " " + _toDisplayString(comment?.user_type == 'alumni' && [0, 1].includes(comment?.is_deleted_in_30_days) ? `（ ${comment?.display_name} ）` : ''), 1))
                  ], 2),
                  _createElementVNode("div", _hoisted_22, [
                    (!comment?.published)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_23))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(Submenu, {
                        revert: !_ctx.checkChatBelongLoggedInUser,
                        menu: _unref(menu),
                        onShowDeleteCommentModal: showDeleteCommentModal,
                        onShowUpdateCommentErrorModal: showUpdateCommentErrorModal,
                        onShowUpdateStatusCommentModal: showUpdateStatusCommentModal,
                        onClick: 
                  () => {
                    setCurrentComment(comment.id, comment.published)
                    setCommentData(comment.post_id, comment.id, comment.published)
                    getComments()
                  }
                ,
                        published: comment?.published
                      }, null, 8, ["revert", "menu", "onClick", "published"])
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(!comment?.published ? 'opacity-30' : '')
                }, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(dayjs)(comment?.created_at).format('YYYY/MM/DD HH:mm')), 1),
                  _createVNode(TargetTag, {
                    data: comment?.comment,
                    class: _normalizeClass('mb-0 fs-7 text-break break-spaces'),
                    users: __props.mention_users
                  }, null, 8, ["data", "users"])
                ], 2)
              ], 2)
            ], 8, _hoisted_16))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(PortfolioAlumni),
    _createVNode(PortfolioUser)
  ], 64))
}
}

})